<!-- 销售出入库管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="mr-24 mb-24 w300" type="text" v-model="storePrams.keywords" placeholder="请输入单号/产品码编码/操作说明/操作员关键词"></Input>
            <Select class="mr-24 mb-24 w200" v-model="storePrams.logistics_company_id" clearable filterable placeholder="请选择承运物流,支持搜索">
                <Option v-for="item in logisticsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <Select class="mr-24 mb-24 w200" v-model="storePrams.store_id" clearable filterable placeholder="请选择收货门店名称">
                <Option v-for="item in storeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <DatePicker class="mr-24 mb-24 w200" type="daterange" split-panels placement="bottom-start" placeholder="选择时间段" separator=" 至 " @on-change="changeDate"></DatePicker>
            <Select class="mr-24 mb-24 w200" v-model="storePrams.agent_id" clearable filterable placeholder="请选择发货的代理名称">
                <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.agent_name }}</Option>
            </Select>
            <Select class="mr-24 mb-24 w200" v-model="storePrams.shipper_type" clearable filterable placeholder="请选择发货类型">
                <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <Input class="mr-24 mb-24 w200" type="text" v-model="storePrams.logistics_number" placeholder="请输入物流单号"></Input>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <div>
                <div v-if="lists.length">
                    <div v-for="(item,index) of lists" :key="index">
                        <div class="div_box">
                            <div class="box_header flex-sb">
                                <div>
                                    <span>订单编号：{{item.order_no}}</span>
                                    <Button class="ml-12" v-if="item.shipper_type == 1" type="success">发货给代理商</Button>
                                    <Button class="ml-12" v-if="item.shipper_type == 2" type="success">发货给门店</Button>
                                    <Button class="ml-12" v-if="item.shipper_type == 3" type="success">零售出库</Button>
                                    <Button class="ml-12" v-if="item.shipper_type == 4">退给代理商</Button>
                                    <Button class="ml-12" v-if="item.shipper_type == 5">退给门店</Button>
                                    <Button class="ml-12" v-if="item.shipper_type == 6">退回总部</Button>
                                </div>
                                <div>发货时间：{{item.logistics_time}}</div>
                            </div>
                            <div class="box_content flex-sb">
                                <template v-if="item.incoming_qrcode[0]">
                                    <img class="width_height_60" v-if="item.incoming_qrcode[0].product" :src="item.incoming_qrcode[0].product.show_product_imgs[0]">
                                </template>
                                <img class="width_height_60" v-else src="../../assets/example1.png">
                                <div>
                                    <div v-if="item.incoming_qrcode[0]">{{ item.incoming_qrcode[0].product ? item.incoming_qrcode[0].product.product_name : ''}}</div>
                                    <div>共计<span class="t-color">{{item.incoming_qrcode_count}}</span>个溯源码</div>
                                </div>
                                <div>
                                    <div>发货方：{{item.from_type_text}}</div>
                                    <div>收货方：
                                        <span style="margin-right: 6px">{{ item.shipper_type_text }}</span>
                                        {{ item.agent ? item.agent.agent_name : '' }}</div>
                                </div>
                                <div v-if="item.status == 1" style="color: #53C41A;"><Icon type="ios-checkmark-circle-outline" color="#53C41A"/>已完成</div>
                                <div v-if="item.status == 2" style="color: #FF4838;"><Icon type="ios-close-circle-outline" color="#FF4838"/>失败</div>
                                <div>
                                    <Button v-if="item.status == 1" type="warning" ghost @click="goBack(item)">退回</Button>
                                    <Button class="ml-12" v-if="item.status == 1" type="success" ghost @click="goInfo(item)">录入物流信息</Button>
                                    <Button class="ml-12" type="success" ghost @click="goDrawer(item)">详情</Button>
                                    <Button class="ml-12" type="error" ghost @click="goDel(1, item)">删除</Button>
                                </div>
                            </div>
                            <div class="box_footer flex-sb">
                                <div>备注说明：{{item.reason}}</div>
                                <div>创建时间：{{item.created_at}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="none_div" v-else>
                    <img src="../../assets/background1.png">
                    <div>暂无数据~</div>
                </div>
            </div>
            <div class="page" v-if="lists.length!=0">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange" />
            </div>
        </div>
        <!-- 详情 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="80">
            <div>
                <div class="drawer_div">
                    <div class="drawer_box">
                        <div>
                            单据编号：{{formData.order_no}}
                            <Button class="ml-12" v-if="formData.shipper_type == 1" type="success">发货给代理商</Button>
                            <Button class="ml-12" v-if="formData.shipper_type == 2" type="success">发货给门店</Button>
                            <Button class="ml-12" v-if="formData.shipper_type == 3" type="success">零售出库</Button>
                            <Button class="ml-12" v-if="formData.shipper_type == 4">退给代理商</Button>
                            <Button class="ml-12" v-if="formData.shipper_type == 5">退给门店</Button>
                            <Button class="ml-12" v-if="formData.shipper_type == 6">退回总部</Button>
                        </div>
                        <div>发货单位：{{formData.from_type_text}}</div>
                        <div>收货单位：
                            <span style="margin-right: 6px">{{ formData.shipper_type_text }}</span>
                            {{ formData.agent ? formData.agent.agent_name : '' }}</div>
                        <div>发货时间：{{formData.logistics_time}}</div>
                        <div>创建时间：{{formData.created_at}}</div>
                        <div>操作人员：{{formData.operator ? formData.operator.user : ''}}</div>
                        <div>备注说明：{{formData.reason}}</div>
                    </div>
                    <div class="complete_div">
                        <Icon type="ios-checkmark-circle-outline" color="53C41A" size="38"/>
                        <span class="ml-12">已完成</span>
                    </div>
                </div>
                <Table :columns="columnsDrawer" :data="dataDrawer" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="show_product_imgs">
                        <div class="flex-c">
                            <img class="width_height_60 mt-12 mb-12" v-if="row.product" :src="row.product.show_product_imgs[0]">
 	                        <img class="width_height_60 mt-12 mb-12" v-else src="../../assets/example1.png">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_name">
                        <div>{{ row.product ? row.product.product_name : '' }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="specs">
                        <div>{{ row.product.specs }}</div>
                    </template>
                </Table>
                <div class="page">
                    <Page :current="pageDrawer.page" :page-size="pageDrawer.limit" :total="totalDrawer" show-elevator show-total  @on-change="pageDrawerChange"/>
                </div>
            </div>
        </Drawer>
        <!-- 录入物流信息 -->
        <Modal v-model="infoModal" title="录入物流信息" width="70" :mask-closable="false">
            <div>
                <Button class="theme-bg mb-24" type="warning" @click="goModal">新增流程和物流信息</Button>
                <Table :columns="columnsInfo" :data="dataInfo" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="start">
                        <div v-if="row.start">{{ row.start }} - {{row.end}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="code">
                        <div>{{ row.code[0] }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost label="small" @click="goModal(row)">编辑</Button>
                            <Button type="error" ghost @click="goDel(2, row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page :current="pageInfo.page" :page-size="pageInfo.limit" :total="totalInfo" show-elevator show-total @on-change="pageInfoChange"/>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增/编辑 -->
        <Modal v-model="modals" :title="modalTitle" width="700" :mask-closable="false">
            <div>
                <div class="modal_div">
                    <img class="width_height_24 mr-12" src="../../assets/information.png">
                    <div>
                        <div>不填写“溯源码”或“ID号段”则代表所有的产品都是同一条物流信息。</div>
                        <div>同一溯源码编码多次录入物流信息，则自动覆盖上一条物流信息，保留最后一次录入的物流信息</div>
                    </div>
                </div>
                <Form :model="formItem" label-position="right" :label-width="100">
                    <FormItem label="物流公司：">
                        <Select class="w300" v-model="formItem.logistics_company_id" clearable filterable placeholder="请选择物流公司" :label-in-value="true" @on-change="changeLogistics">
                            <Option v-for="item in logisticsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="物流单号：">
                        <Input class="w300" type="text" v-model="formItem.logistics_number" placeholder="请输入物流单号"></Input>
                    </FormItem>
                    <FormItem v-if="modalID == 1" label="选择条件：">
                        <RadioGroup v-model="formItem.type" type="button">
                            <Radio label="1">录入码数据</Radio>
                            <Radio class="mr-24 ml-24" label="2">按ID号段</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem v-if="modalID == 1 && formItem.type == '1'" label="溯源码：">
                        <Input class="width_500" type="textarea" v-model="code" :autosize="{minRows: 6}" placeholder="一行一个，支持手工录入和扫码枪扫码录入 可以同时录入产品码，小箱码，大箱码 系统会智能分析查询匹配，自动批量智能处理。"></Input>
                    </FormItem>
                    <FormItem v-if="modalID == 1 && formItem.type == '2'" label="ID号段：">
                        <Input class="width_100" type="text" v-model="formItem.start" placeholder="请输入起始ID"></Input>
                        <span class="mr-12 ml-12">---</span>
                        <Input class="width_100" type="text" v-model="formItem.end" placeholder="请输入截止ID"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelForm">取消</Button>
                <Button class="theme-bg ml-24" type="warning" @click="submitForm">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { 
    incoming_list, 
    incoming_delete, 
    incoming_info, 
    incoming_back, 
    incoming_logistics, 
    incoming_logistics_del, 
    incoming_enter,
} from '@/api/index';
import { incoming_select, store_select, agent_select } from '@/api/select';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                keywords: "",
                logistics_company_id: "",
                store_id: "",
                agent_id: "",
                start_date: "",
                end_date: "",
                shipper_type: "",
                logistics_number: "",
            },
            total: 0,
            logisticsList: [],
            storeList: [],
            agentList: [],
            typeList: [
                { id: 1, name: "发货给代理商" },
                { id: 2, name: "发货给门店" },
                { id: 3, name: "零售出库" },
                { id: 4, name: "退给代理商" },
                { id: 5, name: "退给门店" },
                { id: 6, name: "退回总部" },
            ],
            lists: [],
            drawers: false,
            drawerTitle: '',
            pageDrawer: {
                id: "",
                page: 1,
                limit: 10,
            },
            totalDrawer: 0,
            columnsDrawer: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: '产品图片', slot: "show_product_imgs", align: 'center' },
                { title: '产品名称', slot: 'product_name', align: 'center' },
                { title: '规格', slot: 'specs', align: 'center' },
                { title: '产品编码', key: 'qrcode_number', align: 'center' },
            ],
            dataDrawer: [],
            formData: {
                order_no: "",
                shipper_type: "",
                from_type_text: "",
                shipper_type_text: "",
                logistics_time: "",
                reason: "",
                status: "",
                agent: { agent_name: "" },
                operator: { user: "" },
                created_at: "",
            },
            infoModal: false,
            columnsModal: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: '产品图片', slot: "show_product_imgs", align: 'center' },
                { title: '产品名称', slot: 'product_name', align: 'center' },
                { title: '规格', slot: 'specs', align: 'center' },
                { title: '产品编码', key: 'qrcode_number', align: 'center' },
            ],
            dataModal: [],
            pageInfo: {
                id: "",
                page: 1,
                limit: 10,
            },
            totalInfo: 0,
            columnsInfo: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: 'ID号段', slot: "start", align: 'center' },
                { title: '溯源码', slot: 'code', align: 'center' },
                { title: '物流公司', key: 'logistics', align: 'center' },
                { title: '物流单号', key: 'logistics_number', align: 'center' },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataInfo: [],
            modals: false,
            modalTitle: "",
            modalID: "",
            formItem: {
                id: "",
                incoming_outgoing_id: "",
                logistics: "",
                logistics_number: "",
                type: "1",
                start: "",
                end: "",
                code: [],
                logistics_company_id: "",
            },
            code: "",
        };
    },
    mounted() {
        this.getList();
        this.getIncomingSelect();
        this.getStoreSelect();
        this.getAgentSelect();
    },
    methods: {
        getList() {
            incoming_list(this.storePrams).then((res) => {
                this.lists = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageDrawerChange(index) {
            this.pageDrawer.page = index;
            this.getIncomingInfo();
        },
        pageInfoChange(index){
            this.pageInfo.page = index;
            this.getIncomingLogistics();
        },
        goSearch() {
            this.getList();
        },
        getIncomingSelect(){
            incoming_select().then((res) => {
                this.logisticsList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getStoreSelect(){
            store_select().then((res) => {
                this.storeList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getAgentSelect(){
            agent_select().then((res) => {
                this.agentList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeDate(e){
            if(e[0]){
                this.storePrams.start_date = e[0];
                this.storePrams.end_date = e[1];
            }else {
                this.storePrams.start_date = '';
                this.storePrams.end_date = '';
            }
        },
        // 记录详情里的商品溯源码列表
        getIncomingInfo(){
            incoming_info(this.pageDrawer).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goDrawer(row){
            this.drawerTitle = '查看单据为【'+ row.order_no +'】的发货或退货记录详情';
            this.formData = row;
            this.pageDrawer.id = row.id;
            this.getIncomingInfo();
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        // 退回
        goBack(row){
            let that = this;
            this.$Modal.confirm({
                title: '退回提示',
                content: '确认退回吗？一经退回无法复原',
                onOk: () => {
                    incoming_back({ id:row.id }).then(res=>{
                        that.getList();
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                },
                onCancel: () => {
                }
            }); 
        },
        goDel(index, row){
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 1){
                        incoming_delete({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        }) 
                    }
                    if(index == 2){
                        incoming_logistics_del({ id:row.id }).then(res=>{
                            that.getIncomingLogistics();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        }) 
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        goInfo(row){
            this.pageInfo.id = row.id;
            this.getIncomingLogistics();
            this.formItem.incoming_outgoing_id = row.id;
            setTimeout(() => {
                this.infoModal = true;
            }, 300);
        },
        // 物流列表
        getIncomingLogistics(){
            incoming_logistics(this.pageInfo).then((res) => {
                this.dataInfo = res.data.data;
                this.totalInfo = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goModal(row){
            if(row.id){
                this.modalID = 0;
                this.modalTitle = "编辑流程和物流信息";
                this.formItem.id = row.id;
                this.formItem.logistics = row.logistics;
                this.formItem.logistics_number = row.logistics_number;
                this.formItem.logistics_company_id = row.logistics_company_id;
                this.formItem.type = row.type + '';
                this.formItem.start = row.start;
                this.formItem.end = row.end;
            }else {
                this.modalID = 1;
                this.modalTitle = "新增流程和物流信息";
                this.formItem.id = "";
                this.formItem.logistics = "";
                this.formItem.logistics_number = "";
                this.formItem.type = "1";
                this.formItem.start = "";
                this.formItem.end = "";
                this.formItem.code = [];
                this.formItem.logistics_company_id = "";
                this.code = "";
            }
            this.modals = true;
        },
        cancelForm(){
            this.modals = false;
        },
        changeLogistics(e){
            if(e){
                this.formItem.logistics_company_id = e.value;
                this.formItem.logistics = e.label;
            }else{
                this.formItem.logistics_company_id = "";
                this.formItem.logistics = "";
            }
        },
        // 确定（提交表单）
        submitForm(){
            if(this.code){
                this.formItem.code = this.code.split('\n').map((item, index) => {
                    if (item === '') {
                        // 如果是空字符串，表示这里有一个换行
                        return null;
                    }
                    return item;
                });
            }
            this.formItem.code = this.formItem.code.filter(item => item != null);
            incoming_enter(this.formItem).then( res => {
                this.getIncomingLogistics();
                this.modals = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.div_box{
    margin: 0 0 12px 0;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #EAEAEA;
}
.box_header {
    padding: 12px;
    background: #F7F7F7;
    box-shadow: 0px 1px 0px 0px rgba(234,234,234,0.99);
    border-radius: 5px 5px 0px 0px;
}
.box_content {
    padding: 12px;
    background: rgba(247,247,247,0);
    box-shadow: 0px 1px 0px 0px rgba(234,234,234,0.99);
    font-weight: 400;
    font-size: 14px;
    color: #747B95;
}
.box_footer {
    padding: 12px;
    background: rgba(247,247,247,0);
    box-shadow: 0px 1px 0px 0px rgba(234,234,234,0.99);
    border-radius: 0px 0px 5px 5px;
}
.width_height_60 {
    width: 60px;
    height: 60px;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.none_div {
    text-align: center;
    color: #999;
}
.drawer_div {
    margin: 0 12px 12px 12px;
    display: flex;
    justify-content: space-between;
}
.drawer_box {
    font-size: 15px;
    color: #484E66;
    font-weight: 500;
}
.complete_div {
    font-size: 26px;
    color: #53C41A;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.modal_div {
    padding: 24px;
    margin-bottom: 12px;
    background: rgba(255,118,29,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.width_height_24 {
    width: 24px;
    height: 24px;
}
.width_500 {
    width: 500px;
}
.width_100 {
    width: 100px;
}
</style>